import { inject } from 'aurelia-framework';
import { ToolsService } from 'pages/utilities/tools/service';
import { AuthService } from 'pages/login/service';
import toastr from 'toastr';

@inject(ToolsService, AuthService)
export class UserManager {
    constructor(toolsService, authService) {
        this.authService = authService;
        this.toolsService = toolsService;
    }

    canActivate() {
        return this.authService.user.roleName === 'ADMIN';
    }

    async activate() {
        this.users = await this.toolsService.getUsers();
        this.roles = await this.toolsService.getRoles();
    }

    async updateRoles() {
        if (this.isRequesting) return;
        this.isRequesting = true;
        try {
            const userRoles = this.users.map(user => ({
                userId: user.id,
                roleId: user.roleId
            }));
            await this.toolsService.updateRoles(userRoles);
            toastr.success('Roles updated successfully');
        } catch (error) {
            toastr.error('Failed to update roles');
            console.error(error);
        } finally {
            this.isRequesting = false;
        }
    }
}